import { api } from "@/lib/api";

export const dashboardApi = {
  meta: () => api.get("/dashboard/meta").then((r) => r.data),
  executive: () => api.get("/dashboard/executive").then((r) => r.data),
  production: () => api.get("/dashboard/production").then((r) => r.data),
  inventory: () => api.get("/dashboard/inventory").then((r) => r.data),
  dispatch: () => api.get("/dashboard/dispatch").then((r) => r.data),
  finance: () => api.get("/dashboard/finance").then((r) => r.data),
};

export const VIEW_LABELS = {
  executive: "Executive",
  production: "Production",
  inventory: "Inventory",
  dispatch: "Dispatch",
  finance: "Finance",
};

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const inr2 = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
